import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../Components/PageHeader";
import SignUpTabs from "../Components/SignUpTabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import {
  patientSignUp,
  postSignUp,
  signupCity,
  signupCountry,
  signupStates,
} from "../network/Network";
import { Requirederror } from "../Utils/Helperfunction";

const UserSignUp = () => {
  // checkbox
  const navigate = useNavigate();
  // State hooks
  const [isHomeChecked, setIsHomeChecked] = useState(false);
  const [isOfficeChecked, setIsOfficeChecked] = useState("");
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState([]);
  const [getCountry, setGetcountry] = useState([]);
  const [getCountryid, setGetCountryid] = useState("");
  const [getCityid, setGetCityid] = useState("");
  const [getCity, setGetCity] = useState([]);
  const [getState, setGetState] = useState([]);
  const [getStateid, setGetStateid] = useState("");
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    password: "",
    city: "",
    state: "",
    confirm_password: "",
    zip_code: "",
    country: "",
    address_type: "",
    address: "",
  });

  // Country API call
  useEffect(() => {
    signupCountry().then((res) => {
      setGetcountry(res?.data?.data);
    });
  }, []);

  // State API call based on selected country
  useEffect(() => {
    if (getCountryid) {
      signupStates(getCountryid)
        .then((res) => {
          setGetState(res?.data?.data);
        })
        .catch((err) => {});
    }
  }, [getCountryid]);

  // City API call based on selected state
  useEffect(() => {
    if (getStateid) {
      signupCity(getStateid)
        .then((res) => {
          setGetCity(res?.data?.data);
        })
        .catch((err) => {});
    }
  }, [getStateid]);

  // Form input change handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Checkbox change handler
  const handleOfficeCheckboxChange = (e) => {
    setIsOfficeChecked(e.target.value);
  };

  const handleCountryChange = (e) => {
    setGetCountryid(e.target.value);
  };

  const handleStateChange = (e) => {
    setGetStateid(e.target.value);
  };

  const handleCityChange = (e) => {
    setGetCityid(e.target.value);
  };

  // Password visibility toggle
  const [passwordVisibility, setPasswordVisibility] = useState({
    firstPassword: false,
    secondPassword: false,
  });

  const togglePasswordVisibility = (field) => {
    setPasswordVisibility((prevVisibility) => ({
      ...prevVisibility,
      [field]: !prevVisibility[field],
    }));
  };

  // Sign up form submission handler
  const SignUphanlder = (e) => {
    e.preventDefault();
    setLoading(true);

    let isValid = true;
    const errors = {};

    // Validation
    if (!userData.first_name) {
      errors.first_name = ["First Name is required"];
      isValid = false;
    }
    if (!userData.last_name) {
      errors.last_name = ["Last Name is required"];
      isValid = false;
    }
    if (!userData.phone) {
      errors.phone = ["Phone is required"];
      isValid = false;
    } else if (userData.phone.length < 8 || userData.phone.length > 10) {
      errors.phone = ["Phone number must be between 8 to 10 digits"];
      isValid = false;
    }
    if (!userData.email) {
      errors.email = ["Email is required"];
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(userData.email)) {
      errors.email = ["Email is invalid"];
      isValid = false;
    }
    if (!userData.password) {
      errors.password = ["Password is required"];
      isValid = false;
    } else if (userData.password.length < 8) {
      errors.password = ["Password must be at least 8 characters long"];
      isValid = false;
    }
    if (!userData.confirm_password) {
      errors.confirm_password = ["Confirm Password is required"];
      isValid = false;
    } else if (userData.password !== userData.confirm_password) {
      errors.confirm_password = ["Passwords do not match"];
      isValid = false;
    }
    if (!userData.address) {
      errors.address = ["Address is required"];
      isValid = false;
    }
    if (!isOfficeChecked) {
      errors.isOfficeChecked = ["Kindly select one address type"];
      isValid = false;
    }
    if (!getCountryid) {
      errors.country = ["Country is required"];
      isValid = false;
    }
    if (!getCityid) {
      errors.city = ["City is required"];
      isValid = false;
    }
    if (!userData.zip_code) {
      errors.zip_code = ["Zip code is required"];
      isValid = false;
    } else if (userData.zip_code.length !== 5) {
      errors.zip_code = ["Zip code must be 5 digits"];
      isValid = false;
    }
    if (!getStateid) {
      errors.state = ["State is required"];
      isValid = false;
    }

    setFormErrors(errors);
    setTimeout(() => {
      setFormErrors([]);
    }, 3500);

    if (isValid) {
      const data = {
        first_name: userData.first_name,
        last_name: userData.last_name,
        email: userData.email,
        phone: userData.phone,
        password: userData.password,
        confirm_password: userData.confirm_password,
        city: getCityid,
        state: getStateid,
        zip_code: userData.zip_code,
        country: getCountryid,
        address_type: isOfficeChecked,
        address: userData.address,
        type: "patient",
      };

      patientSignUp(data)
        .then((res) => {
          Swal.fire({
            position: "center",
            icon: "success",
            text: "Congratulations! Your registration has been successfully completed",
            showConfirmButton: false,
            timer: 1500,
          });
          navigate("/sign-in");
          setUserData({
            first_name: "",
            last_name: "",
            phone: "",
            email: "",
            password: "",
            confirm_password: "",
            city: "",
            state: "",
            country: "",
            zip_code: "",
            address_type: "",
            address: "",
          });
          setLoading(false);
        })
        .catch((err) => {
          const errorMessage =
            err?.response?.data?.errors?.email?.[0] ||
            err?.response?.data?.errors?.error?.[0] ||
            "An error occurred. Please try again.";

          Swal.fire({
            position: "center",
            icon: "error",
            text: errorMessage,
            showConfirmButton: false,
            timer: 2000,
          });
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <PageHeader pagename="SignUp" />
      <section className="signup">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mx-auto">
              <div className="signup-wrappper">
                <h2 className="main-heading-font dark-color  level-2 text-center mt-3  mb-4">
                  Sign up
                </h2>
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <div className="d-flex align-items-center justify-content-center">
                      <SignUpTabs />
                    </div>
                  </div>
                </div>
                <form>
                  <div className="row">
                    <div className="form-group col-lg-6">
                      <label htmlFor="">
                        <h5 className="primary-medium-font level-7 ">
                          First Name
                        </h5>
                        <input
                          type="text"
                          className="form-control"
                          id="firstName"
                          placeholder=" First Name"
                          name="first_name"
                          onChange={handleChange}
                          value={userData?.first_name}
                        />
                        <p className="forms-error">{formErrors?.first_name}</p>
                      </label>
                    </div>
                    <div className="form-group col-lg-6">
                      <label htmlFor="">
                        <h5 className="primary-medium-font level-7 ">
                          Last Name
                        </h5>
                        <input
                          type="text"
                          className="form-control"
                          id="last_name"
                          placeholder=" Last Name"
                          name="last_name"
                          onChange={handleChange}
                          value={userData?.last_name}
                        />
                        <p className="forms-error">{formErrors?.last_name}</p>
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label htmlFor="">
                        <h5 className="primary-medium-font level-7 ">Email</h5>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder=" Email"
                          name="email"
                          value={userData?.email}
                          onChange={handleChange}
                        />
                        <p className="forms-error">{formErrors?.email}</p>
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label htmlFor="">
                        <h5 className="primary-medium-font level-7 ">Phone</h5>
                        <input
                          type="number"
                          className="form-control"
                          id="phone"
                          placeholder="Enter Phone"
                          name="phone"
                          value={userData?.phone}
                          onChange={handleChange}
                        />
                        <p className="forms-error">{formErrors?.phone}</p>
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label htmlFor="">
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="primary-medium-font level-7 ">
                            Address
                          </h5>
                          <div className="d-flex align-items-center gap-2">
                            <div className="checkbox-container d-flex align-items-center gap-2">
                              <input
                                type="checkbox"
                                id="home"
                                value="home"
                                className="custom-checkbox"
                                checked={isOfficeChecked === "home"}
                                onChange={handleOfficeCheckboxChange}
                              />
                              <label
                                className="mb-0 extra-color-15 level-7"
                                htmlFor="home"
                              >
                                Home
                              </label>
                            </div>
                            <div className="checkbox-container d-flex align-items-center gap-2">
                              <input
                                type="checkbox"
                                id="office"
                                value="office"
                                className="custom-checkbox"
                                checked={isOfficeChecked === "office"}
                                onChange={handleOfficeCheckboxChange}
                              />
                              <label
                                className="mb-0 extra-color-15 level-7"
                                htmlFor="office"
                              >
                                Office
                              </label>
                            </div>
                            <p className="forms-error">
                              {formErrors?.isOfficeChecked}
                            </p>
                          </div>
                        </div>

                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          placeholder="Address"
                          name="address"
                          value={userData?.address}
                          onChange={handleChange}
                        />
                        <p className="forms-error">{formErrors?.address}</p>
                      </label>
                    </div>
                  </div>

                  <div className="row">
                    <div className="form-group col-lg-12"></div>
                    <div className="form-group col-lg-12 mb-3">
                      <div className="country_dv">
                        <h5 className="primary-medium-font level-7 ">
                          Country
                        </h5>
                        <select
                          id="countrySelect"
                          onChange={handleCountryChange}
                        >
                          <option>Choose a country</option>
                          {getCountry?.map((country) => (
                            <option key={country?.id} value={country?.id}>
                              {country?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <p className="forms-error">{formErrors?.country}</p>

                     
                    </div>

                    <div className="form-group col-lg-12 mb-3">
                      <div className="country_dv">
                        <h5 className="primary-medium-font level-7 ">State</h5>

                        <select id="idstateSelect" onChange={handleStateChange}>
                          <option>Choose a state</option>
                          {getState?.map((state) => (
                            <option key={state?.id} value={state?.id}>
                              {state?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <p className="forms-error">{formErrors?.state}</p>
                    </div>
                    <div className="form-group col-lg-12 mb-3">
                      <div className="country_dv">
                        <h5 className="primary-medium-font level-7 ">City</h5>
                        <select id="idstateSelect" onChange={handleCityChange}>
                          <option>Choose a city</option>
                          {getCity?.map((city) => (
                            <option key={city?.id} value={city?.id}>
                              {city?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <p className="forms-error">{formErrors?.city}</p>
                    </div>
                    <div className="form-group col-lg-12">
                      <label htmlFor="">
                        <h5 className="primary-medium-font level-7 ">
                          Zip code
                        </h5>

                        <input
                          type="number"
                          className="form-control"
                          id="zip_code"
                          placeholder="Zip Code"
                          name="zip_code"
                          value={userData?.zip_code}
                          onChange={handleChange}
                        />
                        <p className="forms-error">{formErrors?.zip_code}</p>
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label htmlFor="firstPassword">
                        <h5 className="primary-medium-font level-7">
                          Password
                        </h5>
                        <div className="password-container">
                          <input
                            type={
                              passwordVisibility.firstPassword
                                ? "text"
                                : "password"
                            }
                            className="form-control"
                            id="firstPassword"
                            placeholder="********"
                            name="password"
                            value={userData?.password}
                            onChange={handleChange}
                          />
                          <p className="forms-error">{formErrors?.password}</p>

                          <span
                            className="eye-icon"
                            onClick={() =>
                              togglePasswordVisibility("firstPassword")
                            }
                          >
                            <FontAwesomeIcon
                              icon={
                                passwordVisibility.firstPassword
                                  ? faEyeSlash
                                  : faEye
                              }
                            />
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-lg-12">
                      <label htmlFor="secondPassword">
                        <h5 className="primary-medium-font level-7">
                          Confirm Password
                        </h5>
                        <div className="password-container">
                          <input
                            type={
                              passwordVisibility.secondPassword
                                ? "text"
                                : "password"
                            }
                            className="form-control"
                            id="secondPassword"
                            placeholder="********"
                            name="confirm_password"
                            value={userData?.confirm_password}
                            onChange={handleChange}
                          />
                          <p className="forms-error">
                            {formErrors?.confirm_password}
                          </p>

                          <span
                            className="eye-icon"
                            onClick={() =>
                              togglePasswordVisibility("secondPassword")
                            }
                          >
                            <FontAwesomeIcon
                              icon={
                                passwordVisibility.secondPassword
                                  ? faEyeSlash
                                  : faEye
                              }
                            />
                          </span>
                        </div>
                      </label>
                    </div>
                  </div>
                  <Link
                    className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
                    to=""
                  >
                    <span
                      onClick={(e) => SignUphanlder(e)}
                      className="loading-btn loading bg-wrapper w-100"
                    >
                      {loading ? <i className="fa fa-spinner"></i> : "Sign Up"}
                    </span>
                  </Link>
                  <h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
                    Already have an account?{" "}
                    <Link
                      to="/sign-in"
                      className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
                    >
                      Sign In
                    </Link>
                  </h4>
                </form>
              </div>
            </div>
            <h4 className=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
              By Becoming a member, you agree to our{" "}
              <Link
                to="/terms-of-service"
                className="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
              >
                <span className="primary-semibold-font">
                  {" "}
                  Terms & Conditions{" "}
                </span>
              </Link>
            </h4>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UserSignUp;
